(function ($, root) {
	window.rdoInfinite = {
		loader: $("#infinite-loader"),
		container: $("#infinite-loader .infinite-container"),
		bulletcontainer: $("#infinite-loader .bullet-container"),
		continueButton: $(".bullet-wrapper .continue"),
		type: $("#infinite-loader").attr("data-val"),
		current: 0,
		busy: false,
		// end: false,
		page: 1,
		currentElement: 1,
		counter: 0,
		size: 3,
		alldone: false,
		items: $("#infinite-loader .infinite-container .item"),
		itemtemplate: $("#infinite-item-template"),
		bullettemplate: $("#infinite-bullet-template"),
		ending: $("#scrollend"),
		icons: {
			loading: $("#scrollend .busyloading"),
			end: $("#scrollend .endfadeout"),
		},
		scrollify_options: {
			section: ".item",
			sectionName: "section-name",
			setHeights: false,
			easing: "",
			before: function (i, panels) {
				var ref = panels[i].attr("data-section-name");
				$("#infinite-loader .bullet-container .active").removeClass("active");
				$("#infinite-loader .bullet-container")
					.find('[target-section-name="' + ref + '"]')
					.addClass("active");
			},
		},
	};
	$.fn.showForAwhile = function (duration) {
		duration = duration || 1000;
		var elem = $(this);
		elem.fadeIn(500);

		setTimeout(function () {
			elem.animate(
				{
					height: "0",
				},
				500,
				function () {}
			);
		}, duration);
	};
	$.fn.activateBullet = function (bullet) {
		// bullet = bullet || null;
		window.rdoInfinite.bulletcontainer.find("li").removeClass("active");
		window.rdoInfinite.bulletcontainer
			.find("#bullet-" + bullet)
			.addClass("active");
	};
	$.fn.returnBgStyle = function (color1, color2) {
		return `
background: ${color1}; /* Old browsers */
background: -moz-linear-gradient(top, ${color1} 0%, ${color2} 100%); /* FF3.6-15 */
background: -webkit-linear-gradient(top, ${color1} 0%,${color2} 100%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(to bottom, ${color1} 0%,${color2} 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='${color1}', endColorstr='${color2}',GradientType=0 ); /* IE6-9 */
      `;
	};

	$.fn.loadNext = function () {
		if (!window.rdoInfinite.busy && !window.rdoInfinite.alldone) {
			console.log("now getting");
			window.rdoInfinite.busy = true;
			let lang = "";
			if (window.language == "en") {
				lang = "/en";
			}

			var url =
				lang +
				"/jsonout/page/" +
				window.rdoInfinite.page +
				"/?contents=" +
				window.rdoInfinite.type +
				"&post_per_page=" +
				window.rdoInfinite.size +
				"&language=" +
				window.language;

			// window.rdoInfinite.icons.loading.fadeIn();
			// $.scrollify.disable();

			$.ajax({
				url: url,
				method: "GET",
				// headers: headers,
				data: null,
				dataType: "json",
				success: function (data) {
					// console.log(data.length, 'items');

					if (data.length) {
						// console.log(data)

						data.forEach(function (currentValue, index, arr) {
							currentValue.index =
								window.rdoInfinite.size * (window.rdoInfinite.page - 1) + index;
							currentValue.gradient = $.fn.returnBgStyle(
								currentValue.ustRenk,
								currentValue.altRenk
							);
							if (window.rdoInfinite.itemtemplate.length) {
								window.rdoInfinite.container.append(
									window.rdoInfinite.itemtemplate.render(currentValue)
								);
							}
							if (window.rdoInfinite.bullettemplate.length) {
								window.rdoInfinite.bulletcontainer.append(
									window.rdoInfinite.bullettemplate.render(currentValue)
								);
							}
						});
						if (window.rdoInfinite.loader.attr("data-scrollify") == "true") {
							if (window.rdoInfinite.page == 1) {
								window.rdoInfinite.bulletcontainer
									.find("#bullet-0")
									.addClass("active");
								$.scrollify(window.rdoInfinite.scrollify_options);
							} else {
								$.scrollify.update();
							}
						} else {
							window.rdoInfinite.icons.loading.hide();
							window.rdoInfinite.icons.end.show();
							setTimeout(function () {
								window.rdoInfinite.icons.end.fadeOut();
							}, 1000);
						}

						window.rdo.LazyLoad.update();
						// window.rdoInfinite.icons.end.showForAwhile(2000);
						// window.rdoInfinite.icons.loading.hide();
						window.rdoInfinite.page++;
						window.rdoInfinite.busy = false;

						//get items list again.
						window.rdoInfinite.items = $(
							"#infinite-loader .infinite-container .item"
						);
					} else {
						// console.log('all done');
						window.rdoInfinite.alldone = true;
					}
				},
				error: function (request, status, error) {
					// console.log(error);
					// console.log('all done');
					window.rdoInfinite.alldone = true;

					window.rdoInfinite.busy = false;
					window.rdoInfinite.icons.loading.hide();
					window.rdoInfinite.icons.end.show();
					setTimeout(function () {
						window.rdoInfinite.icons.end.fadeOut();
					}, 1000);

					// window.rdoInfinite.icons.end.showForAwhile(2000);
					// window.rdoInfinite.icons.loading.hide();
				},
				beforeSend: function (xhr) {
					xhr.setRequestHeader("Authorization");
				},
			});
		} else {
			console.log("still trying");
		}
	};

	// $.scrollify.move("#name");

	$.startInfiniteLoader = function () {
		if (window.rdoInfinite.loader.length) {
			window.rdoInfinite.icons.end.hide();
			window.rdoInfinite.icons.loading.hide();
			window.rdoInfinite.loader.loadNext();
			window.rdoInfinite.currentElement = 1;

			if (window.rdoInfinite.loader.attr("data-scrollify") == "true") {
				$.scrollify(window.rdoInfinite.scrollify_options);

				$(document).scroll(function () {
					if (window.rdoInfinite.currentElement != $.scrollify.currentIndex()) {
						//compare index with previous (or it gets same index for multiple times.)
						window.rdoInfinite.currentElement = $.scrollify.currentIndex();
						// console.log('current' + window.rdoInfinite.currentElement);
						// console.log('total' + window.rdoInfinite.items.length);

						// $.fn.activateBullet(window.rdoInfinite.currentElement);

						//do sth when scrolled to another;
						// https://projects.lukehaas.me/scrollify/#home

						// https://codyhouse.co/gem/page-scroll-effects/
					}
					if (
						window.rdoInfinite.currentElement >=
						window.rdoInfinite.items.length - 3
					) {
						if (!window.rdoInfinite.alldone) {
							window.rdoInfinite.loader.loadNext();
						}
					}
				});
			} else {
				$(document).scroll(function () {
					// console.log('scrolling');
					var top_of_element = window.rdoInfinite.ending.offset().top;
					var bottom_of_element =
						window.rdoInfinite.ending.offset().top +
						window.rdoInfinite.ending.outerHeight();
					var bottom_of_screen =
						$(window).scrollTop() + $(window).innerHeight();
					var top_of_screen = $(window).scrollTop();

					if (
						bottom_of_screen > top_of_element &&
						top_of_screen < bottom_of_element &&
						!window.rdoInfinite.busy
					) {
						if (!window.rdoInfinite.alldone) {
							window.rdoInfinite.icons.loading.show();
							window.rdoInfinite.loader.loadNext();
						} else {
							window.rdoInfinite.icons.end.show();
						}
						// the element is visible, do something
					} else {
						// the element is not visible, do something else
					}
				});
			}

			// $.fn.activateBullet($.scrollify.currentIndex());

			$(document).on("click", ".bullet-container li", function () {
				var target = $(this).attr("target-section-name");
				// console.log(target);
				$.scrollify.move("#" + target);
			});

			window.rdoInfinite.continueButton.click(function () {
				window.rdoInfinite.loader.loadNext();
			});
		}
	};
})(jQuery, this);
